import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

const state = {
  utente: localStorage.getItem('utente') || 'ko',
  user: null,
  sidebarShow: "responsive",
  sidebarMinimize: false,
  aree: [],
  url_versione: "",
};

const mutations = {
  CLEAR_AUTH(state) {
    state.utente = 'ko';
    state.user = null;
  },
  toggleSidebarDesktop(state) {
    const sidebarOpened = [true, "responsive"].includes(state.sidebarShow);
    state.sidebarShow = sidebarOpened ? false : "responsive";
  },
  toggleSidebarMobile(state) {
    const sidebarClosed = [false, "responsive"].includes(state.sidebarShow);
    state.sidebarShow = sidebarClosed ? true : "responsive";
  },
  set(state, [variable, value]) {
    state[variable] = value;
  },
  user_login(state, url) {
    state.utente = "ok";
    axios.post(url).then((response) => {
      console.log("versione " + response.data);
      // localStorage.setItem("versione", response.data);
    });
    localStorage.setItem("utente", state.utente);
  },
  user_logout(state) {
    state.utente = 'ko';
    localStorage.setItem('utente', state.utente);
    localStorage.clear();
  },
  lista_aree(state, payload) {
    state.aree = payload;
  },
};

const actions = {
  logout({ commit }) {
    // azzera lo stato applicativo
    commit('CLEAR_AUTH');

    // rimuovi chiavi note dal localStorage
    try {
      const whitelist = []; // es. ['theme'] se vuoi preservare qualcosa
      const preserve = {};
      whitelist.forEach(k => { if (localStorage.getItem(k) !== null) preserve[k] = localStorage.getItem(k); });

      localStorage.removeItem('utente');
      localStorage.removeItem('userID');
      localStorage.removeItem('chisono_data');
      localStorage.removeItem('token');
      localStorage.removeItem('tokenElearning');
      localStorage.clear();

      Object.keys(preserve).forEach(k => localStorage.setItem(k, preserve[k]));
    } catch (e) { /* no-op */ }

    // sessionStorage
    try { sessionStorage.clear(); } catch (e) { /* no-op */ }

    // cookie (best effort, lato client)
    try {
      const cookies = document.cookie ? document.cookie.split(';') : [];
      const paths = ['/']; // base app
      const domains = (() => {
        const host = window.location.hostname;
        const parts = host.split('.');
        const ds = ['']; // dominio corrente senza 'domain='
        for (let i = parts.length - 2; i >= 0; i--) {
          ds.push('.' + parts.slice(i).join('.'));
        }
        return ds;
      })();

      cookies.forEach(c => {
        const eq = c.indexOf('=');
        const name = (eq > -1 ? c.substr(0, eq) : c).trim();
        paths.forEach(p => {
          // senza domain
          document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${p}`;
          // con varianti di domain
          domains.forEach(d => {
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${p};domain=${d}`;
          });
        });
      });
    } catch (e) { /* no-op */ }

    // axios (se lo usi)
    if (window.axios) {
      delete window.axios.defaults.headers.common['Authorization'];
      delete window.axios.defaults.headers.common['authorization'];
    }
  }
};

export default new Vuex.Store({
  state,
  mutations,
  actions
});
